<script>
import axios from 'axios';

export default {
  props: {
    apiUrl: {
      type: String
    },
    initialData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      data: this.initialData ? this.initialData : {},
      numberToShowOnPageLoad: this.initialData
        ? this.initialData.numberToShowOnPageLoad
        : 0,
      itemsKey: 'items'
    };
  },

  computed: {
    items() {
      return this.data ? this.data[this.itemsKey] : [];
    },

    isViewAll() {
      return this.items && this.items.length === this.visibleItems.length;
    },

    isButtonVisible() {
      if (this.items && this.items.length <= this.data.numberToShowOnPageLoad) {
        return false;
      } else {
        return true;
      }
    },

    visibleItems() {
      if (this.items) {
        return this.items.slice(0, this.numberToShowOnPageLoad);
      }
      return [];
    }
  },

  created() {
    if (!this.initialData) {
      this.fetchData();
    }
  },

  methods: {
    toggleAmount() {
      if (this.isViewAll) {
        this.numberToShowOnPageLoad = this.data.numberToShowOnPageLoad;
      } else {
        this.numberToShowOnPageLoad = this.items.length;
      }
    },

    fetchData() {
      axios.get(this.apiUrl).then(response => {
        this.data = response.data;
        this.numberToShowOnPageLoad = this.data.numberToShowOnPageLoad;
      });
    }
  }
};
</script>